import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

import { useCardClick } from 'hooks/use-card-click';
import { useCardViewer } from 'hooks/use-card-viewer';
import { useRedirect } from 'hooks/use-redirect';
import { setAskKlueShowModal } from 'store/views/dashboard';

import { SingleCardViewer } from './partials/single-card-viewer';

import type { RootState } from 'store/store.types';

export default function CardViewer() {
  const navigate = useNavigate();
  const { redirectToCompany } = useRedirect();
  const {
    currentCardId,
    currentCardRank,
    targetCard,
    close: closeCardViewer,
    open: openCardViewer,
    targetProfile,
    failed,
    loadCard,
  } = useCardViewer();
  const location = useLocation();
  const ignoreCardDefferLoading =
    !location.pathname.includes('/profile') ||
    location.pathname.includes('/embed');

  const { isProfileReady } = useSelector((state: RootState) => state.app);
  const shouldShowCardViewer = isProfileReady || ignoreCardDefferLoading;

  useCardClick((cardId, profileId, isBattlecard, search) => {
    if (isBattlecard && profileId) {
      // Keep the link's query string: it carries the `cardId` deep link that
      // tells the battlecard which card to open.
      return navigate({
        pathname: `/profile/${profileId}/battlecard/view/${cardId}`,
        search,
      });
    }
    openCardViewer(+cardId);
  });

  const handleLaneClick = () => {
    if (!targetCard?.id) return false;

    const searchParams = new URLSearchParams({
      lanes: targetCard.board.id.toString(),
    });

    setAskKlueShowModal(false);
    navigate({
      pathname: `/profile/${targetProfile?.id}`,
      search: searchParams.toString(),
    });
  };

  const handleCardProfileClick = () => {
    if (!targetProfile?.id) return false;
    setAskKlueShowModal(false);
    redirectToCompany(targetProfile?.id);
  };

  useEffect(() => {
    if (currentCardId) {
      loadCard(currentCardId);
    }
  }, [loadCard, currentCardId]);

  if (!shouldShowCardViewer) {
    return null;
  }

  if (currentCardId) {
    return (
      <SingleCardViewer
        profile={targetProfile}
        card={targetCard}
        onClose={closeCardViewer}
        onLaneClick={handleLaneClick}
        onProfileClick={handleCardProfileClick}
        loadFailed={failed}
        rank={currentCardRank}
      />
    );
  }

  return null;
}
